import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: resolve =>
        require(["../components/pages/homepage.vue"], resolve)
    },
    {
      path: "/helloworld",
      component: resolve => require(["../components/HelloWorld.vue"], resolve)
    },
    // {
    //   path: '/meeting/barrage',
    //   component: resolve => require(['../components/pages/annualMeeting/barrage.vue'], resolve),
    // },
    {
      path: "*",
      component: resolve => require(["../components/common/404.vue"], resolve)
    },
    {
      path: "/jump",
      component: resolve => require(["../components/common/jump.vue"], resolve)
    },
    {
      path: "/carInsurance",
      component: resolve =>
        require(["../components/pages/homeInsurance/carInsurance.vue"], resolve)
    },
    {
      path: "/insuranceBrand",
      component: resolve =>
        require([
          "../components/pages/homeInsurance/insuranceBrand.vue"
        ], resolve)
    },
    {
      path: "/insurancewarehorse",
      component: resolve =>
        require([
          "../components/pages/homeInsurance/insurancewarehorse.vue"
        ], resolve)
    },
    {
      path: "/goldConsultant",
      component: resolve =>
        require([
          "../components/pages/homeInsurance/goldConsultant.vue"
        ], resolve)
    },
    {
      path: "/groupInsurance",
      component: resolve =>
        require([
          "../components/pages/homeInsurance/groupInsurance.vue"
        ], resolve)
    },
    {
      path: "/aboutUs",
      component: resolve =>
        require(["../components/pages/about/aboutUs.vue"], resolve)
    },
    {
      path: "/help/center",
      component: resolve =>
        require(["../components/pages/helpCenter/helpcenter.vue"], resolve)
    },
    {
      path: "/notice",
      component: resolve =>
        require(["../components/pages/notice/notice.vue"], resolve)
    },
    {
      path: "/notice/companyProfile",
      component: resolve =>
        require(["../components/pages/notice/companyProfile.vue"], resolve)
    },
    {
      path: "/insurance/details",
      component: resolve =>
        require(["../components/pages/insuranceDetails/index.vue"], resolve)
    },
    {
      path: "/integrity",
      component: resolve =>
        require(["../components/pages/homeInsurance/integrity.vue"], resolve)
    },
    {
      path: "/link",
      component: resolve =>
        require(["../components/pages/registered.vue"], resolve)
    },
    {
      path: "/test",
      component: resolve =>
        require(["../components/pages/assignee/test.vue"], resolve)
    },
    {
      path: "/home",
      component: resolve => require(["../components/common/home.vue"], resolve), //把公共的部分放到home页面就可以了，需要公共部分的页面就放到home的children里
      children: [
        {
          path: "/agentCenter",
          component: resolve =>
            require(["../components/pages/userAgency/agentCenter.vue"], resolve)
        },
        {
          path: "/userAgencyRegistered",
          component: resolve =>
            require([
              "../components/pages/userAgency/userAgencyRegistered.vue"
            ], resolve)
        },
        {
          path: "/userAgencyBind",
          component: resolve =>
            require([
              "../components/pages/userAgency/userAgencyBind.vue"
            ], resolve)
        },
        {
          path: "/userAgencyUpgrade",
          component: resolve =>
            require([
              "../components/pages/userAgency/userAgencyUpgrade.vue"
            ], resolve)
        },
        {
          path: "/teamInsurance",
          component: resolve =>
            require([
              "../components/pages/homeInsurance/teamInsurance.vue"
            ], resolve)
        },
        {
          path: "/companyInsurance",
          component: resolve =>
            require([
              "../components/pages/homeInsurance/companyInsurance.vue"
            ], resolve)
        },
        {
          path: "/liabilityInsurance",
          component: resolve =>
            require([
              "../components/pages/homeInsurance/liabilityInsurance.vue"
            ], resolve)
        },
        {
          path: "/agentBalance",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/agentBalance.vue"
            ], resolve)
        },
        {
          path: "/orderManagement",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/orderManagement.vue"
            ], resolve)
        },
        {
          path: "/orderManagement/details",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/orderManagementDetails.vue"
            ], resolve)
        },
        {
          path: "/orderManagement/evaluate",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/orderManagementEvaluate.vue"
            ], resolve)
        },
        {
          path: "/agentfile",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/agentfile.vue"
            ], resolve)
        },
        {
          path: "/clientManagement",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/clientManagement.vue"
            ], resolve)
        },
        {
          path: "/clientManagement/info",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/clientInfo.vue"
            ], resolve)
        },
        {
          path: "/policyInsurance/add",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/policyInsuranceAdd.vue"
            ], resolve)
        },
        {
          path: "/personal/center",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/personalCenter.vue"
            ], resolve)
        },
        {
          path: "/personal/datum",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/datum.vue"
            ], resolve)
        },
        {
          path: "/personal/orderManagement",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/orderManagement.vue"
            ], resolve)
        },
        {
          path: "/personal/orderManagement/show",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/orderShow.vue"
            ], resolve)
        },
        {
          path: "/personal/orderManagement/details",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/orderManagementDetails.vue"
            ], resolve)
        },
        {
          path: "/personal/policyManagement",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/policyManagement.vue"
            ], resolve)
        },
        {
          path: "/personal/policyInsurance/add",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/policyInsuranceAdd.vue"
            ], resolve)
        },
        {
          path: "/personal/agentDrafts",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/agentDrafts.vue"
            ], resolve)
        },
        {
          path: "/personal/agentRecord",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/agentRecord.vue"
            ], resolve)
        },
        {
          path: "/personal/agentRenewal",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/agentRenewal.vue"
            ], resolve)
        },
        {
          path: "/personal/agentIntegral",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/agentIntegral.vue"
            ], resolve)
        },
        {
          path: "/personal/agentGift",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/agentGift.vue"
            ], resolve)
        },
        {
          path: "/personal/favorite",
          component: resolve =>
            require([
              "../components/pages/userAgency/personalCenter/favorite.vue"
            ], resolve)
        },
        //客户订单，保单
        {
          path: "/agent/orderManagement",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/orderManagement.vue"
            ], resolve)
        },
        {
          path: "/agent/policyManagement",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/policyManagement.vue"
            ], resolve)
        },
        //订单详情
        {
          path: "/orderManagementDetail",
          component: resolve =>
            require([
              "../components/pages/userAgency/orderManagementDetail.vue"
            ], resolve)
        },
        //保单详情
        {
          path: "/policyDetail",
          component: resolve =>
            require([
              "../components/pages/userAgency/policyDetail.vue"
            ], resolve)
        },
        //太保支付结果页
        {
          path: "/payResult",
          component: resolve =>
            require(["../components/pages/payResult/success.vue"], resolve)
        },

        {
          path: "/contrast",
          component: resolve =>
            require(["../components/pages/contrast.vue"], resolve)
        },
        {
          path: "/productDutyOrder",
          query: {
            mallId: "",
            secondId: ""
          },
          component: resolve =>
            require(["../components/pages/productDutyOrder.vue"], resolve)
        },
        {
          path: "/assignee/assigneeApplication",
          query: {
            mallId: "",
            secondId: ""
          },
          component: resolve =>
            require([
              "../components/pages/assignee/assigneeApplication.vue"
            ], resolve)
        },
        {
          path: "/assignee/assigneeUpload",
          query: {
            mallId: "",
            secondId: ""
          },
          component: resolve =>
            require([
              "../components/pages/assignee/assigneeUpload.vue"
            ], resolve)
        },
        {
          path: "/backPassword",
          component: resolve =>
            require(["../components/pages/backPassword.vue"], resolve)
        },
        {
          path: "/withdraw",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/withdraw.vue"
            ], resolve)
        },
        {
          path: "/agentDrafts",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/agentDrafts.vue"
            ], resolve)
        },
        {
          path: "/agentShare",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/agentShare.vue"
            ], resolve)
        },
        {
          path: "/agentRecord",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/agentRecord.vue"
            ], resolve)
        },
        {
          path: "/agentRenewal",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/agentRenewal.vue"
            ], resolve)
        },
        {
          path: "/agentIntegral",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/agentIntegral.vue"
            ], resolve)
        },
        {
          path: "/agentGift",
          component: resolve =>
            require([
              "../components/pages/userAgency/agentMessage/agentGift.vue"
            ], resolve)
        },
        {
          path: "/localStore",
          component: resolve =>
            require(["../components/pages/store/localStore.vue"], resolve)
        },
        {
          path: "/storeDetail",
          component: resolve =>
            require(["../components/pages/store/storeDetail.vue"], resolve)
        },
        {
          path: "/insure",
          component: resolve =>
            require(["../components/pages/insure/insure.vue"], resolve)
        },
        {
          path: "/payment",
          component: resolve =>
            require(["../components/pages/insure/payment.vue"], resolve)
        },
        {
          path: "/insureMessage",
          component: resolve =>
            require(["../components/pages/insure/insureMessage.vue"], resolve)
        },
        {
          path: "/searchResult",
          component: resolve =>
            require(["../components/pages/search/searchResult.vue"], resolve)
        },
        {
          path: "/pointsCenter",
          component: resolve =>
            require(["../components/pages/points/pointsCenter.vue"], resolve)
        },
        {
          path: "/measuringPremiumTPYJCX",
          component: resolve =>
            require([
              "../components/pages/measuringPremium/measuringPremiumTPYJCX.vue"
            ], resolve)
        },
        {
          path: "/measuringPremiumTPYJCX/pay",
          component: resolve =>
            require(["../components/pages/measuringPremium/pay.vue"], resolve)
        },
        {
          path: "/measuringPremiumTPYJCX/productOrder",
          component: resolve =>
            require([
              "../components/pages/measuringPremium/productOrder.vue"
            ], resolve)
        },
        {
          path: "/measuringPremiumTPYJCX/payResult",
          component: resolve =>
            require([
              "../components/pages/measuringPremium/payResult.vue"
            ], resolve)
        },
        // {
        //   path: '/categoryLists',
        //   component: resolve => require(['../components/pages/categoryLists.vue'], resolve)
        // },
        {
          path: "/secondClass",
          component: resolve =>
            require(["../components/pages/secondClass.vue"], resolve)
        },
        {
          path: "/pointsShop",
          component: resolve =>
            require(["../components/pages/points/pointsShop.vue"], resolve)
        },
        {
          path: "/shopDetail",
          component: resolve =>
            require(["../components/pages/points/shopDetail.vue"], resolve)
        },
        {
          path: "/pointsOrder",
          component: resolve =>
            require(["../components/pages/points/pointsOrder.vue"], resolve)
        },
        {
          path: "/carInsuranceDetail",
          component: resolve =>
            require([
              "../components/pages/homeInsurance/carInsuranceDetail.vue"
            ], resolve)
        }
      ]
    },
    {
      path: "/firstClass",
      component: resolve =>
        require(["../components/pages/firstClass.vue"], resolve)
    },
    //年会活动
    {
      path: "/annualMeeting/draw",
      component: resolve =>
        require(["../components/pages/annualMeeting/draw.vue"], resolve)
    },
    {
      path: "/annualMeeting/specialDraw",
      component: resolve =>
        require(["../components/pages/annualMeeting/specialDraw.vue"], resolve)
    },
    {
      path: "/annualMeeting/topDraw",
      component: resolve =>
        require(["../components/pages/annualMeeting/topDraw.vue"], resolve)
    },
    {
      path: "/annualMeeting/drawResult",
      component: resolve =>
        require(["../components/pages/annualMeeting/drawResult.vue"], resolve)
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js